import { useState } from "react";
import { X } from "lucide-react";
import { toISO } from "../../utils/date.js";

export default function ExportModal({ open, payload, onClose }) {
  const [copied, setCopied] = useState(false);
  if (!open) return null;

  const today = toISO(new Date());
  const filename = `trip-planner-${today}.json`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(payload);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const ta = document.getElementById("export-textarea");
      if (ta) { ta.select(); document.execCommand("copy"); setCopied(true); setTimeout(() => setCopied(false), 2000); }
    }
  };

  const tryDownload = () => {
    try {
      const blob = new Blob([payload], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch {
      alert("Direct download blocked in this environment — copy the text below and save it manually as " + filename);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4 bg-slate-900/50 backdrop-blur-sm" onClick={onClose}>
      <div
        className="w-full sm:max-w-lg bg-white dark:bg-slate-800 rounded-t-3xl sm:rounded-3xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 pt-5 pb-3 flex items-center justify-between border-b border-slate-100 dark:border-slate-700">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100" style={{ fontFamily: "'Fraunces', Georgia, serif" }}>
            Export trip
          </h2>
          <button onClick={onClose} className="p-1.5 rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400">
            <X size={18} />
          </button>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed">
            Backup snapshot of this trip. Save as <code className="px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-[11px]">{filename}</code>.
          </p>
          <textarea
            id="export-textarea"
            readOnly
            value={payload}
            onClick={(e) => e.target.select()}
            className="w-full h-48 p-3 text-[11px] font-mono bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-xl resize-none text-slate-700 dark:text-slate-300"
          />
          <div className="flex gap-2">
            <button
              onClick={copy}
              className="flex-1 px-4 py-2.5 rounded-full bg-slate-900 dark:bg-slate-600 text-white font-medium hover:bg-slate-700 dark:hover:bg-slate-500 transition-colors text-sm"
            >
              {copied ? "Copied ✓" : "Copy to clipboard"}
            </button>
            <button
              onClick={tryDownload}
              className="px-4 py-2.5 rounded-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 font-medium hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors text-sm"
            >
              Try download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
